import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FaPenToSquare, FaRegTrashCan } from "react-icons/fa6";
import { toast } from "react-toastify";
import { API_ciudadanos } from "../../config/apiConfig";
import "../../pages/admin/css/Expediente.css";
import { useAuth } from "../../context/AuthContext";

const Notas = ({ usuario, setUsuario }) => {
  const { user } = useSelector((state) => state.auth);
  const { token } = useAuth();
  const [notes, setNotes] = useState([]);
  const [newNoteText, setNewNoteText] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingText, setEditingText] = useState("");

  useEffect(() => {
    if (usuario?.notasTecnico) {
      const textosNotas = usuario.notasTecnico.map((n) => n.texto);
      setNotes(textosNotas);
    }
  }, [usuario]);

  const handleAddNote = async () => {
    const nuevaNota = newNoteText.trim();
    if (nuevaNota === "") return;

    try {
      const response = await fetch(
        `${API_ciudadanos}/${usuario.userId}/agregarNota`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": token,
          },
          body: JSON.stringify({
            nombreTecnico: user?.name || "Técnico",
            texto: nuevaNota,
            fecha: new Date().toISOString(),
          }),
        }
      );

      if (!response.ok) throw new Error("Error al guardar la nota.");

      // Crear la nueva nota localmente para actualizar el estado inmediatamente
      const nuevaNotaCompleta = {
        nombreTecnico: user?.name || "Técnico",
        texto: nuevaNota,
        fecha: new Date().toISOString(),
      };

      // Actualizar las notas locales inmediatamente
      const notasActualizadas = [
        ...(usuario?.notasTecnico || []),
        nuevaNotaCompleta,
      ];
      setNotes(notasActualizadas.map((n) => n.texto));

      // Actualizar el estado del usuario en el componente padre
      if (setUsuario) {
        setUsuario((prevUsuario) => ({
          ...prevUsuario,
          notasTecnico: notasActualizadas,
        }));
      }

      setNewNoteText("");
      toast.success("Nota añadida correctamente");
    } catch (error) {
      console.error("Error guardando nota:", error);
      toast.error("Error al guardar la nota");
    }
  };

  const handleEditNote = (index) => {
    setEditingIndex(index);
    setEditingText(notes[index]);
  };

  const handleSaveEdit = async (index) => {
    try {
      // /ciudadanos/:userId/editarNota/:index
      await fetch(`${API_ciudadanos}/${usuario.userId}/editarNota/${index}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify({
          texto: editingText.trim(),
          fecha: new Date().toISOString(),
        }),
      });
      // locally update the notes
      const updatedNotes = [...notes];
      updatedNotes[index] = editingText.trim();
      setNotes(updatedNotes);
      setEditingIndex(null);
      setEditingText("");
    } catch (e) {
      console.error("Error al guardar la edición:", e);
      toast.error("Error al guardar la nota editada");
      return;
    }
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditingText("");
  };

  const handleDeleteNote = async (index) => {
    try {
      const response = await fetch(
        `${API_ciudadanos}/${usuario.userId}/eliminarNota/${index}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": token,
          },
        }
      );

      if (!response.ok) throw new Error("Error al eliminar la nota.");

      const data = await response.json();
     
      // Actualizar las notas locales inmediatamente
      const notasActualizadas = [...(usuario?.notasTecnico || [])];
      notasActualizadas.splice(index, 1);
      setNotes(notasActualizadas.map((n) => n.texto));

      // Actualizar el estado del usuario en el componente padre
      if (setUsuario) {
        setUsuario((prevUsuario) => ({
          ...prevUsuario,
          notasTecnico: notasActualizadas,
        }));
      }

      toast.success("Nota eliminada correctamente");
    } catch (error) {
      console.error("Error eliminando nota:", error);
      toast.error("Error al eliminar la nota");
    }
  };

  return (
    <div className="notas">
      <h2 className="blanco mayusculas">NOTAS</h2>

      <ul className="contenido">
        {notes.map((note, index) => (
          <li key={index} className="nota">
            {editingIndex === index ? (
              <div className="editar-nota column">
                <textarea
                  aria-label="Editar la nota"
                  value={editingText}
                  onChange={(e) => setEditingText(e.target.value)}
                />
                <div className="botones-editar flex">
                  <button onClick={() => handleSaveEdit(index)}>Guardar</button>
                  <button onClick={handleCancelEdit}>Cancelar</button>
                </div>
              </div>
            ) : (
              <div>
                <p>{note}</p>
                <div className="botones-nota flex">
                  <button
                    aria-label="Editar esta nota"
                    onClick={() => handleEditNote(index)}
                  >
                    <FaPenToSquare />
                  </button>
                  <button
                    aria-label="Eliminar esta nota"
                    onClick={() => handleDeleteNote(index)}
                  >
                    <FaRegTrashCan />
                  </button>
                </div>
              </div>
            )}
          </li>
        ))}

        <li className="nueva-nota column">
          <textarea
            aria-label="Escribir nota nueva"
            placeholder="Añade una nota nueva..."
            value={newNoteText}
            onChange={(e) => setNewNoteText(e.target.value)}
          />
          <button onClick={handleAddNote}>Añadir Nota</button>
        </li>
      </ul>
    </div>
  );
};

export default Notas;
